//import { gsap } from 'gsap';
import DOMHelpers from './utils/dom-helpers';

// ----------- INCLUDE ALL THE WIDGETS ---------------------//
import slideshowSwiper from './widgets/slideshowSwiper';
import selectComponent from './widgets/selectComponent';
import multiSelectComponentFilters from './widgets/multiSelectComponentFilters';
import simpleToggle from './widgets/simpleToggle';
import listArtists from './widgets/listArtists';
import windowTeamBio from './widgets/windowTeamBio';
//import windowEnlargeImages from './widgets/windowEnlargeImages';    
import contactFormModule from './widgets/contactFormModule';
import gdprBar from './widgets/gdprBar';
// import videoPlayer from './widgets/videoPlayer';
//import mailchimpNewsletterForm from './widgets/mailchimpNewsletterForm';
import bonterraNewsletterForm from './widgets/bonterraNewsletterForm';
import moduleSubmenuBarbaView from './widgets/moduleSubmenuBarbaView'; 

export default class WIDGETS {

    constructor(options) {

        this.defaults = {
            main: undefined
        };
        this.options = {};
        Object.assign(this.options, this.defaults, options);

        this.namespace = 'widgets';
        this.main = this.options.main;

        // DOM helpers
        this.dom = new DOMHelpers(document);
        this.qs = this.dom.qs.bind(this.dom);
        this.qsa = this.dom.qsa.bind(this.dom);
        this.on = this.dom.on.bind(this.dom);
        this.off = this.dom.off.bind(this.dom);
        this.addClass = this.dom.addClass.bind(this.dom);
        this.removeClass = this.dom.removeClass.bind(this.dom);
        this.hasClass = this.dom.hasClass.bind(this.dom);
        this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);

        this.body = document.body;

        this.shopify = false;

        // this.audioPlayer = undefined;
        // this.videoWindow = undefined;
    }

    // context: DOM element or falsy (document). b = enable/disable, firstTime = initial load
    initWidgets(_context, b, firstTime) {

        // const root = context || document; // kept for potential widget initialization

        // widgets initialized only one time, when page load !!!
        if (firstTime) {
           
            this.initGdprBar();
            this.initNewsletterForm(true);
        } else {

        }

        this.initSlideShowsSwiper(b);
        this.initSelectComponents(b);
        this.initMultiSelectComponentFilters(b);
        this.initSimpleToggle(b);
        this.initListArtists(b);
        this.initWindowTeamBio(b);
        //this.initWindowEnlargeImages(b);
        this.initContactFormModule(b);
        this.initModuleSubmenuBarbaView(b);
        // this.embedDonationEmbedCode(firstTime, b);
    }


    /* Converted commented jQuery blocks below -> vanilla DOM + DOMHelpers equivalents (kept commented).
       Remove comment markers to enable and adapt as needed.
    */


    embedDonationEmbedCode(firstTime, b) {
        if ( !b ){
            return;
        }
        if ( b ){
            const element = document.querySelector( '.embed-code' );
            if ( element ){
                const form = element.querySelector('template').content.cloneNode(true);
                element.innerHTML = '';
                element.appendChild( form );
            }   
        }
    }


    initGdprBar() {
        const el = document.getElementById('gdpr-bar');
        if (!el) return;
        const instance = new gdprBar({ main: this.main, el: el });
        this.assign(el, instance);
        this.gdprBar = instance;
    }

    initModuleSubmenuBarbaView ( b, el ){
        const els = (el || document).querySelectorAll('.menu-subpages-view');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const instance = new moduleSubmenuBarbaView({ el: el, main: this.main });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }



    initContactFormModule(b, el=false) {
        const els = (el || document).querySelectorAll('.contact-form-module');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                
                const instance = new contactFormModule({ el: el, main: this.main });
                this.assign(el, instance);
                
            });
        } else {
            this.destroy(els);
        }
    }
    
    initSlideShowsSwiper(b, el=false) {
        const els = (el || document).querySelectorAll('.swiper');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                if ( !el.classList.contains( 'manual-init' ) ){
                    const instance = new slideshowSwiper({ $el: el, main: this.main });
                    this.assign(el, instance);
                }
            });
        } else {
            this.destroy(els);
        }
    }
    
    initSelectComponents(b,el=false){
        const els = (el || document).querySelectorAll('.select-component');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const instance = new selectComponent({ el: el, main: this.main });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }

    initMultiSelectComponentFilters(b,el=false){
        const els = (el || document).querySelectorAll('.multi-select-filters');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const instance = new multiSelectComponentFilters({ el: el, main: this.main });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }

    initSimpleToggle(b,el=false){
        const els = (el || document).querySelectorAll('.simple-toggle');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const instance = new simpleToggle({ el: el, main: this.main });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }

    initListArtists(b,el=false){
        const s = (el || document).querySelector('#list-artists-container');
        if (!s ) return;
        if (b) {
            const instance = new listArtists({ el: s, main: this.main });
            this.assign(s, instance);
        } else {
            this.destroy(s);
        }
    }

    initWindowTeamBio(b,el=false ){
        const s = (el || document).querySelector('#team-bio-overlay');
        if (!s ) return;
        if (b) {
            const instance = new windowTeamBio({ el: s, main: this.main });
            this.assign(s, instance);
        } else {
            this.destroy(s);
        }    
    }

    initWindowEnlargeImages(b,el=false ){
        const s = (el || document).querySelector('#window-enlarge-images');
        if (!s ) return;
        if (b) {
            const instance = new windowEnlargeImages({ el: s, main: this.main });
            this.assign(s, instance);
        } else {
            this.destroy(s);
        }    
    }

    /*
    initVideoPlayer(b, root) {
        const els = (root || document).querySelectorAll('.video-player');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const instance = new videoPlayer({
                    el,
                    main: this.main,
                    background: el.classList.contains('video-background'),
                    autoplay: el.classList.contains('video-autoplay'),
                    playPause: el.classList.contains('video-play-pause'),
                    autopause: el.classList.contains('video-autopause'),
                    pauseOnStart: el.classList.contains('video-pause-on-start')
                });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }
    */
    
    initNewsletterForm(b, root=false) {
        const els = (root || document).querySelectorAll('.newsletter-window');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                const newsletter = false; //document.querySelector( 'li.newsletter' );
                const anchor    = document.querySelector( 'li.newsletter a' );
                //const instance = new mailchimpNewsletterForm({ el, main: this.main, active: false, attachToElement: newsletter, anchor: anchor });
                const instance = new bonterraNewsletterForm({ el, main: this.main, active: false, attachToElement: newsletter, anchor: anchor });
                this.assign(el, instance);
            });
        } else {
            this.destroy(els);
        }
    }
    
    //------------------------------------------------- UTILS --------------------------------------------------------------------//

    // store instance on element(s)
    assign(elOrEls, widget) {
        if (!elOrEls) return;
        const nodes = (NodeList.prototype.isPrototypeOf(elOrEls) || Array.isArray(elOrEls)) ? Array.from(elOrEls) : [elOrEls];
        nodes.forEach(el => {
            if (!el) return;
            try {
                el.__widget = widget;
            } catch (_e) {
                // fallback: store on dataset by id (not preferred)
                if (!el.dataset.__widgetId) el.dataset.__widgetId = 'w_' + Math.random().toString(36).slice(2, 9);
                window.__widgets = window.__widgets || {};
                window.__widgets[el.dataset.__widgetId] = widget;
            }
        });
    }

    // destroy widget instances attached to element(s)
    destroy(elOrEls) {
        if (!elOrEls) return;
        const nodes = (NodeList.prototype.isPrototypeOf(elOrEls) || Array.isArray(elOrEls)) ? Array.from(elOrEls) : [elOrEls];
        nodes.forEach(el => {
            if (!el) return;
            const widget = el.__widget;
            if (widget && typeof widget.destroy === 'function') {
                try { widget.destroy(); } catch (_e) { /* swallow individual widget errors */ }
            }
            try { delete el.__widget; } catch (_e) { el.__widget = null; }
            if (el.dataset && el.dataset.__widgetId && window.__widgets) {
                delete window.__widgets[el.dataset.__widgetId];
                delete el.dataset.__widgetId;
            }
        });
    }

}